import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import withAdminLayout from '../../layout/withAdminLayout';
import Spinner from '../../components/utilities/Spinner';
import RouteGate from '../../components/utilities/RouteGate';

const Profile = lazy(() => import('../../container/profile/Index'));
const ChangePassword = lazy(() => import('../../container/profile/ChangePassword'));

const ProfileRoutes = () => {

    return (
        <Suspense
            fallback={
                <div className="spin">
                    <Spinner />
                </div>
            }
        >
            <RouteGate router="profile">
                <Routes>
                    <Route path="/" element={<Profile />} />
                    <Route path="/change-password" element={<ChangePassword />} />
                    <Route path="*" element={<Navigate to="/dashboard" />} />
                </Routes>
            </RouteGate>
        </Suspense>
    )
}

export default withAdminLayout(ProfileRoutes);
